const audit = {
  moduleTitle: "سجل التدقيق",
  actions: {
    view: "عرض",
  },
  permissions: {
    core: "النواة",
    auditManagement: "إدارة التدقيق",
    auditLog: "سجل التدقيق",
  },
};

export default audit;
